<template>
  <div name="customunits">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">My Content</h2>
        <dropdown
          v-if="isContentAdmin"
          :options="subjectDropdown"
          :selected="selectedSubject"
          v-on:updateOption="updateSelectedSubject"
          class="w-56 bg-gray-200 text-center"
          v-bind:class="selectedSubject.id > 0 ? 'text-gray-700 ' : ''"
        >
          ></dropdown
        >
      </div>
    </header>

    <div
      class="w-full px-8 h-12 mb-6 bg-white border-b border-gray-200 flex content-center"
    >
      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>

    <router-view :subject="subjectToPass" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "customunits",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      subjects: "subjects",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    tabsList() {
      return this.tabs;
    },
    subjectDropdown() {
      let list = this.subjectsList.map(function (item, index) {
        return { id: item.id, name: item.title };
      });

      if (this.selectedSubject.id === undefined) {
        this.selectedSubject = list[0];
      }
     
      return list;
    },
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    subjectToPass() {
      let vm = this;
      let object = vm.subjectsList.find((s) => s.id === vm.selectedSubject.id);
      if (object != undefined) {
        return object;
      } else {
        return vm.subjectsList[0];
      }
    },
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
      subjectsList: [], //subjects.list,
      selectedSubject: {},
    };
  },
  created() {
    // subjects
    if (this.isContentAdmin) {
      this.subjectsList = this.subjects.systemSubjects;
    } else {
      if (this.subjects.list.length > 0) {
        this.subjectsList = this.subjects.list;
      } else {
        this.subjectsList = [this.subjects.defaultSubject];
      }
    }

    if (this.$store.getters.subject) {
      this.selectedSubject = this.$store.getters.subject
    }

  },
  mounted() {

    // tabs - path
    this.tabs = [
      { id: 1, name: "My Units", path: "custom-units" },
      { id: 2, name: "My Outcomes", path: "custom-outcomes" },
    ];

    if (!this.currentUser.isOrganisation && !this.currentUser.isContentAdmin) {
      this.tabs.push({
        id: 3,
        name: "Planning Outcomes",
        path: "planning-outcomes",
      });
    }

    let found = this.tabs.find((p) => this.$route.path.includes(p.path))
    if (found) {
      this.selectedPath = found
    } else {
      this.selectedPath = this.tabs[0];
    }

  },
  methods: {
    showPath(object) {
      if (this.selectedPath.id === object.id) {
        return;
      }
      this.selectedPath = object;
      this.$router.push("/my-content/" + object.path);
    },
    updateSelectedSubject(value) {
      this.$store.commit("setSubject", value);
      this.selectedSubject = value;
    },
  },
  components: {
    dropdown,
  },
};
</script>

<style scoped>
</style>